// Style constants for UniversalLocationMap component

export const SETUP_ERROR_BOX_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: 'background.neutral',
  border: '2px dashed',
  borderColor: 'divider',
  borderRadius: 2,
  p: 3,
  textAlign: 'center',
} as const;

export const BAIDU_ERROR_BOX_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: 'warning.lighter',
  border: '2px solid',
  borderColor: 'warning.main',
  borderRadius: 2,
  p: 3,
  textAlign: 'center',
} as const;

export const ERROR_STATE_BOX_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: 'error.lighter',
  border: '2px solid',
  borderColor: 'error.light',
  borderRadius: 2,
  p: 3,
  textAlign: 'center',
} as const;

export const LOADING_BOX_STYLES = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

export const MAIN_CONTAINER_STYLES = {
  position: 'relative',
  width: '100%',
} as const;

export const MAP_ELEMENT_STYLES = {
  width: '100%',
  height: '100%',
  borderRadius: 1,
  overflow: 'hidden',
  bgcolor: 'background.neutral',
} as const;

export const SEARCH_OVERLAY_STYLES = {
  position: 'absolute',
  top: 12,
  left: 12,
  right: 12,
  zIndex: 2,
} as const;

export const PROVIDER_INDICATOR_STYLES = {
  position: 'absolute',
  bottom: 8,
  right: 8,
  bgcolor: 'grey.800',
  color: 'common.white',
  px: 1,
  py: 0.5,
  borderRadius: 1,
  fontSize: '12px',
  zIndex: 3,
} as const;

export const INFO_WINDOW_STYLES = {
  position: 'absolute',
  top: 20,
  right: 20,
  zIndex: 4,
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 2,
  p: 2,
  minWidth: 200,
} as const;

export const INFO_WINDOW_CLOSE_BUTTON_STYLES = {
  cursor: 'pointer',
  p: 0.5,
  ml: 1,
} as const;

export const SETUP_ERROR_CODE_BOX_STYLES = {
  fontSize: '12px',
  fontFamily: 'monospace',
  textAlign: 'left',
} as const;

export const SETUP_ERROR_CODE_CONTENT_STYLES = {
  marginTop: '8px',
  padding: '8px',
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
} as const;

export const BAIDU_ERROR_CODE_BOX_STYLES = {
  fontSize: '12px',
  fontFamily: 'monospace',
  textAlign: 'left',
  bgcolor: 'background.paper',
  p: 2,
  borderRadius: 1,
  border: '1px solid',
  borderColor: 'divider',
} as const;
